module.exports = __webpack_public_path__ + "static/media/serena2.2726f185.png";